import Axios from 'axios';

import Cookies from 'universal-cookie';

import { SetListPag } from 'interface/Page';
import { SetUserData } from 'interface/Users';
import { SetListDataSingle } from 'interface/Data';

import { cookiesRegister, typeCookieEmail, typeCookiePassw } from 'fixedData';

// Alt Status data
export function Reg_AltStatus(userId, type, id, origin, status, CallbackSuccess, CallbackError){
    const data    = new FormData();
    data.append("id", id);
    data.append('userId', userId);
    data.append('type_page', origin);
    data.append('edit_data', type);
    data.append('status', status);

    Axios({
        url     : process.env.REACT_APP_API_URL + 'php/page/' + origin + '.php',
        mode    : 'no-cors',
        method  : 'POST',
        data    : data
    })
    .then(response => {
        console.log(response.data);
        SetListDataSingle(origin, response.data[origin]);
        SetListDataSingle('historic', response.data.historic);
        CallbackSuccess();

    }).catch((error)=>{

        CallbackError();
    })
}


// Recover pass
export function CheckedEmail(email, CallbackSuccess, CallbackError, CallbackError_Send, CallbackError_NotEmail){
    const data    = new FormData();

    data.append('type_page', "recover_email");
    data.append('email', email);

    Axios({
        url     : process.env.REACT_APP_API_URL + 'php/inc/recover_pass.php',
        mode    : 'no-cors',
        method  : 'POST',
        data    : data
    })
    .then(response => {
        console.log(response.data);
        switch (response.data) {
            case "Email enviado com sucesso":
                    CallbackSuccess();
                break;
            case "Email não enviado":
                    CallbackError_Send();
                break;
            case "E-mail não encontrado":
                    CallbackError_NotEmail();
                break;
            case "Erro ao enviar mensagem":
                    CallbackError();
                break;
        }

    }).catch((error)=>{

        CallbackError();
    })
}
// Checked pass or alt pass
export function CodeNewPass(type, pass, code, CallbackSuccess, CallbackError){
    const data    = new FormData();

    data.append('type_page', type);
    data.append('pass', pass);
    data.append('code', code);

    Axios({
        url     : process.env.REACT_APP_API_URL + 'php/inc/recover_pass.php',
        mode    : 'no-cors',
        method  : 'POST',
        data    : data
    })
    .then(response => {
        console.log(response.data);
        if(response.data == "conectado"){
            CallbackSuccess();
        }else {
            CallbackError();
        }

    }).catch((error)=>{
        CallbackError();
    })
}


// Edit or register data user
export function Reg_UserDash(userId, idPage, name, email, file, pass, nivel, note, page, CallbackSuccess, CallbackError){
    const data    = new FormData();
    const cookies = new Cookies();

    data.append('type_page', 'access_dash');
    data.append('edit_data', 'edit_or_register');

    data.append('userId', userId);
    data.append('idPage', idPage);
    data.append('name', name);
    data.append('email', email);
    data.append('pass', pass);
    data.append('file', file);
    data.append('nivel', nivel);
    data.append('note', note);

    // new user
    if(idPage == 0){
        page.forEach((elem, index) => {
            data.append('page_id[]', 0);
            data.append('id_project[]', elem.id);
            data.append('type[]', elem.type);
        });

    // edit user
    }else {
        page.forEach((elem, index) => {        
            data.append('page_id[]', elem.id);
            data.append('id_project[]', elem.id_project);
            data.append('type[]', elem.type);
        });
    }

    Axios({
        url     : process.env.REACT_APP_API_URL + 'php/page/access_dash.php',
        mode    : 'no-cors',
        method  : 'POST',
        data    : data
    })
    .then(response => {
        console.log(response.data);
        SetListDataSingle('access_dash', response.data.access_dash);
        if(response.data.idPage !=0){
            SetListPag('currentPageId', response.data.idPage);
        }

        if(userId == idPage){
            const newData = response.data.access_dash.find(item => item.id == userId);
            cookies.set(typeCookieEmail, email, '/', cookiesRegister);
            if(pass !=''){
                cookies.set(typeCookiePassw, response.data.pass, '/', cookiesRegister);
            }

            SetUserData('id', newData['id']);
            SetUserData('file', newData['file']);
            SetUserData('name', newData['name']);
            SetUserData('email', newData['email']);
            SetUserData('access', newData['access']);
            SetUserData('page', newData['page']);
        }

        CallbackSuccess();

    }).catch((error)=>{
        CallbackError();
    })
}
// Edit user logado
export function Reg_UserLogado(userId, name, email, pass, file, CallbackSuccess, CallbackError){
    const data    = new FormData();
    const cookies = new Cookies();

    data.append('type_page', 'access_dash');
    data.append('edit_data', 'edit_user');

    data.append('id', userId);
    data.append('name', name);
    data.append('email', email);
    data.append('pass', pass);
    data.append('file', file);

    Axios({
        url     : process.env.REACT_APP_API_URL + 'php/page/access_dash.php',
        mode    : 'no-cors',
        method  : 'POST',
        data    : data
    })
    .then(response => {
        console.log(response.data);
        SetListDataSingle('access_dash', response.data.access_dash);        
        
        const newData = response.data.access_dash.find(item => item.id == userId);
        SetUserData('file', newData['file']);
        SetUserData('name', newData['name']);
        SetUserData('email', newData['email']);

        // current date
        const day = new Date();

        // add 3 day
        const add3Days = new Date();
        add3Days.setDate(day.getDate() + 2);
        cookies.set(typeCookieEmail, email, { path: '/', expires: add3Days }, cookiesRegister);
        if(pass !=''){
            cookies.set(typeCookiePassw, response.data.pass, { path: '/', expires: add3Days }, cookiesRegister);
        }

        CallbackSuccess();

    }).catch((error)=>{
        CallbackError();
    })
}


// New project
export function Reg_NewProject(userId, title, name, description, logo192, logo512, favicon, CallbackSuccess, CallbackError){
    const data    = new FormData();

    data.append('type_page', 'new_project');
    data.append('userId', userId);
    data.append('title', title);
    data.append('name', name);
    data.append('description', description);
    data.append('logo192', logo192);
    data.append('logo512', logo512);
    data.append('favicon', favicon);

    Axios({
        url     : process.env.REACT_APP_API_URL + 'php/page/project.php',
        mode    : 'no-cors',
        method  : 'POST',
        data    : data
    })
    .then(response => {
        console.log(response.data);        
        SetListDataSingle('project', response.data.project);
        CallbackSuccess();

    }).catch((error)=>{
        CallbackError();
    })
}